import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "colleagues" */ '@/views/colleagues/Index');
let create = () => import(/* webpackChunkName: "colleagues" */ '@/views/colleagues/Create');
let edit = () => import(/* webpackChunkName: "colleagues" */ '@/views/colleagues/Edit');

export default [
    {
        path: "/colleagues",
        name: "colleagues.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['colleagues:viewAny'],
            title: "همکاران"
        }
    },
    {
        path: "/colleagues/create",
        name: "colleagues.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['colleagues:create'],
            title: "ایجاد همکار"
        }
    },
    {
        path: "/colleagues/:colleague",
        name: "colleagues.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['colleagues:update'],
            title: "ویرایش همکار"
        }
    },
]
